import { Route, Routes } from "react-router-dom"
import React from "react"

const GuestListingFormPage = React.lazy(
    () => import("../pages/GuestListingFormPage")
)
const GuestListingFormCompletedPage = React.lazy(
    () => import("../pages/GuestListingFormCompletedPage")
)

export const GuestFormRoutes = () => {
    return (
        <Routes>
            <Route
                path={`completed`}
                element={<GuestListingFormCompletedPage />}
            />
            <Route path={"*"} element={<GuestListingFormPage />} />
        </Routes>
    )
}
